import Swal from 'sweetalert2'

export const alerta = {
  error: (titulo: string, texto: string) =>
    Swal.fire({ icon: 'error', title: titulo, text: texto, confirmButtonText: 'Aceptar' }),
  advertencia: (titulo: string, texto: string) =>
    Swal.fire({ icon: 'warning', title: titulo, text: texto, confirmButtonText: 'Aceptar' }),
  toast: (mensaje: string) =>
    Swal.fire({
      icon: 'success',
      title: mensaje,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    }),
  eliminar: async (titulo: string, texto: string): Promise<boolean> => {
    const r = await Swal.fire({
      icon: 'warning',
      title: titulo,
      text: texto,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    })
    return r.isConfirmed
  },
  confirmar: async (titulo: string, texto: string, botonConfirmar: string): Promise<boolean> => {
    const r = await Swal.fire({
      icon: 'question',
      title: titulo,
      text: texto,
      showCancelButton: true,
      confirmButtonText: botonConfirmar,
      cancelButtonText: 'Cancelar',
    })
    return r.isConfirmed
  },
}
